import { useTranslation } from 'react-i18next';
import * as z from 'zod';

const useFormValidations = () => {
  const { t } = useTranslation();
  const fullNameSchema = z
    .string()
    .trim()
    .min(1, { message: t('app:invalidName') });

  const emailSchema = z
    .string()
    .trim()
    .min(1, { message: t('app:requiredEmail') })
    .email({
      message: t('app:invalidEmail'),
    });
  const passwordSchema = z
    .string()
    .trim()
    .min(1, { message: t('app:requiredPassword') })
    .min(6, { message: t('app:minPassword') });

  const confirmPasswordSchema = z
    .string()
    .trim()
    .min(1, { message: t('app:requiredConfirmPassword') });

  const descriptionSchema = z
    .string()
    .trim()
    .max(512, { message: t('app:maxCompanyDescription', { value: 512 }) });

  const phoneSchema = z
    .string()
    .min(1, { message: t('app:requiredPhone') })
    .min(7, { message: t('app:invalidPhoneMinLength') })
    .regex(/^(?!(\d)\1{5,})/, { message: t('app:sequencePhoneNumber') })
    .regex(/^(?!.*123456789)\d+$/, { message: t('app:sequencePhoneNumber') });

  return {
    fullNameSchema,
    emailSchema,
    phoneSchema,
    passwordSchema,
    confirmPasswordSchema,
    descriptionSchema,
  };
};
export default useFormValidations;
